import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, of, Subject} from 'rxjs';

interface Store {
    [key: string]: BehaviorSubject<any>;
}

@Injectable()
export class ValueShareService {

    store: Store = {};

    constructor() {
    }

    setValue(key: string, value: any) {
        if (!this.store[key]) {
            this.store[key] = new BehaviorSubject(value);
        } else if (this.store[key].getValue() !== value) {
            this.store[key].next(value);
        }
    }

    getValue(key: string): Observable<any> {
        if (!this.store[key]) {
            this.setValue(key, undefined);
        }
        return this.store[key].asObservable();
    }
}
